import { render, staticRenderFns } from "./Highlight.vue?vue&type=template&id=3c62bb5e&scoped=true"
import script from "./Highlight.vue?vue&type=script&lang=js"
export * from "./Highlight.vue?vue&type=script&lang=js"
import style0 from "./Highlight.vue?vue&type=style&index=0&id=3c62bb5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c62bb5e",
  null
  
)

export default component.exports